export default "__VITE_ASSET__CIxGaFRy__"